import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/categories';
import { categories as baseCategories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  illustration: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20illustration%20artwork%20with%20vibrant%20colors%20and%20detailed%20character%20design%2C%20soft%20dreamy%20background%2C%20Japanese%20manga%20style%2C%20clean%20composition%2C%20high%20quality%20digital%20art%2C%20pastel%20color%20palette%20with%20warm%20accents&width=600&height=375&seq=cat-nav-illust&orientation=landscape',
  comic: 'https://readdy.ai/api/search-image?query=Anime%20manga%20comic%20page%20layout%20with%20dynamic%20panels%20and%20expressive%20characters%2C%20black%20and%20white%20line%20art%20with%20screen%20tones%2C%20Japanese%20comic%20aesthetic%2C%20action%20scene%20composition&width=600&height=375&seq=cat-nav-comic&orientation=landscape',
  doujin: 'https://readdy.ai/api/search-image?query=Doujin%20fan%20art%20collection%20featuring%20various%20anime%20characters%20in%20creative%20scenarios%2C%20colorful%20and%20playful%20illustration%20style%2C%20warm%20and%20inviting%20atmosphere&width=600&height=375&seq=cat-nav-doujin&orientation=landscape',
  cosplay: 'https://readdy.ai/api/search-image?query=Professional%20cosplay%20photography%20with%20elaborate%20anime%20character%20costume%20and%20detailed%20props%2C%20studio%20lighting%20with%20soft%20backdrop%2C%20creative%20posing%2C%20high%20quality%20costume%20design&width=600&height=375&seq=cat-nav-cosplay&orientation=landscape',
  voice: 'https://readdy.ai/api/search-image?query=Voice%20acting%20recording%20studio%20with%20professional%20microphone%20and%20anime%20character%20illustrations%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%2C%20sound%20proofing%20panels&width=600&height=375&seq=cat-nav-voice&orientation=landscape',
  animation: 'https://readdy.ai/api/search-image?query=Anime%20animation%20production%20workspace%20with%20storyboard%20sketches%20and%20color%20palettes%2C%20creative%20digital%20drawing%20tablet%2C%20warm%20studio%20lighting&width=600&height=375&seq=cat-nav-anim&orientation=landscape',
};

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            探索创作世界
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            六大创作领域，发现你热爱的二次元世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {baseCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={categoryImages[cat.slug]}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-lg text-foreground-900">
                      {cat.name}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-0.5">
                      {cat.articleCount.toLocaleString()} 篇作品
                    </p>
                  </div>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}